import React, { useEffect, useState } from "react";
import api from "../axiosConfig";
import { getUser } from "../helpers";

const AccountRowData = () => {
  const [data, setData] = useState([]);
  const [loadingSpinner, setLoadingSpinner] = useState(true);
  const [error, setError] = useState(null);
  const user = getUser();

    console.log(data,"data");

  useEffect(() => {
    const fetchData = (user) => {
      setLoadingSpinner(true);

      api
        .get("/api/getaccountpricelist", {
          user: user,
          page: "account-pricelist",
          //   currencyType: currency,
        })
        .then((response) => {
          setData(response.data || []);
          setLoadingSpinner(false);
          // console.log(response.data, "Account price list data");
        })
        .catch((error) => {
          console.error("Error fetching Account price list data:", error);
          setError(error);
          setLoadingSpinner(false);
        });
    };

    fetchData({
      user,
    });
  }, []);

  return { loadingSpinner, data, error };
};

export default AccountRowData;
